/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as GoogleCallbackRouteImport } from './routes/google-callback'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authOtpDogrulamaRouteImport } from './routes/(auth)/otp-dogrulama'
import { Route as authGirisYapRouteImport } from './routes/(auth)/giris-yap'
import { Route as AuthenticatedUrunlerIndexRouteImport } from './routes/_authenticated/urunler/index'
import { Route as AuthenticatedUretimSureciIndexRouteImport } from './routes/_authenticated/uretim-sureci/index'
import { Route as AuthenticatedSssIndexRouteImport } from './routes/_authenticated/sss/index'
import { Route as AuthenticatedSiteAyarlariIndexRouteImport } from './routes/_authenticated/site-ayarlari/index'
import { Route as AuthenticatedSertifikalarIndexRouteImport } from './routes/_authenticated/sertifikalar/index'
import { Route as AuthenticatedSektorlerIndexRouteImport } from './routes/_authenticated/sektorler/index'
import { Route as AuthenticatedSayfalarIndexRouteImport } from './routes/_authenticated/sayfalar/index'
import { Route as AuthenticatedSayfaSeoIndexRouteImport } from './routes/_authenticated/sayfa-seo/index'
import { Route as AuthenticatedReferanslarIndexRouteImport } from './routes/_authenticated/referanslar/index'
import { Route as AuthenticatedMusterilerIndexRouteImport } from './routes/_authenticated/musteriler/index'
import { Route as AuthenticatedMuhendislikIndexRouteImport } from './routes/_authenticated/muhendislik/index'
import { Route as AuthenticatedMedyaIndexRouteImport } from './routes/_authenticated/medya/index'
import { Route as AuthenticatedKullanicilarIndexRouteImport } from './routes/_authenticated/kullanicilar/index'
import { Route as AuthenticatedKategorilerIndexRouteImport } from './routes/_authenticated/kategoriler/index'
import { Route as AuthenticatedIsIlanlariIndexRouteImport } from './routes/_authenticated/is-ilanlari/index'
import { Route as AuthenticatedIletisimMesajlariIndexRouteImport } from './routes/_authenticated/iletisim-mesajlari/index'
import { Route as AuthenticatedHeroSliderIndexRouteImport } from './routes/_authenticated/hero-slider/index'
import { Route as AuthenticatedHakkimizdaIndexRouteImport } from './routes/_authenticated/hakkimizda/index'
import { Route as AuthenticatedHaberlerIndexRouteImport } from './routes/_authenticated/haberler/index'
import { Route as AuthenticatedGlobalHaritaIndexRouteImport } from './routes/_authenticated/global-harita/index'
import { Route as AuthenticatedGaleriIndexRouteImport } from './routes/_authenticated/galeri/index'
import { Route as AuthenticatedEkipIndexRouteImport } from './routes/_authenticated/ekip/index'
import { Route as AuthenticatedBlogIndexRouteImport } from './routes/_authenticated/blog/index'
import { Route as AuthenticatedBasvurularIndexRouteImport } from './routes/_authenticated/basvurular/index'

const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authSifremiUnuttumLazyRouteImport = createFileRoute(
  '/(auth)/sifremi-unuttum',
)()
const authGirisYap2LazyRouteImport = createFileRoute('/(auth)/giris-yap-2')()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedUsersIndexLazyRouteImport = createFileRoute(
  '/_authenticated/users/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedChatsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/chats/',
)()
const AuthenticatedAppsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/apps/',
)()
const AuthenticatedSettingsNotificationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/notifications',
)()
const AuthenticatedSettingsDisplayLazyRouteImport = createFileRoute(
  '/_authenticated/settings/display',
)()
const AuthenticatedSettingsAppearanceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/appearance',
)()
const AuthenticatedSettingsAccountLazyRouteImport = createFileRoute(
  '/_authenticated/settings/account',
)()

const GoogleCallbackRoute = GoogleCallbackRouteImport.update({
  id: '/google-callback',
  path: '/google-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authSifremiUnuttumLazyRoute = authSifremiUnuttumLazyRouteImport
  .update({
    id: '/(auth)/sifremi-unuttum',
    path: '/sifremi-unuttum',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/sifremi-unuttum.lazy').then((d) => d.Route),
  )
const authGirisYap2LazyRoute = authGirisYap2LazyRouteImport
  .update({
    id: '/(auth)/giris-yap-2',
    path: '/giris-yap-2',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(auth)/giris-yap-2.lazy').then((d) => d.Route))
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const authOtpDogrulamaRoute = authOtpDogrulamaRouteImport.update({
  id: '/(auth)/otp-dogrulama',
  path: '/otp-dogrulama',
  getParentRoute: () => rootRouteImport,
} as any)
const authGirisYapRoute = authGirisYapRouteImport.update({
  id: '/(auth)/giris-yap',
  path: '/giris-yap',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexLazyRoute =
  AuthenticatedUsersIndexLazyRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/users/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedChatsIndexLazyRoute =
  AuthenticatedChatsIndexLazyRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/chats/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsIndexLazyRoute =
  AuthenticatedAppsIndexLazyRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/index.lazy').then((d) => d.Route),
  )
const AuthenticatedUrunlerIndexRoute =
  AuthenticatedUrunlerIndexRouteImport.update({
    id: '/urunler/',
    path: '/urunler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUretimSureciIndexRoute =
  AuthenticatedUretimSureciIndexRouteImport.update({
    id: '/uretim-sureci/',
    path: '/uretim-sureci/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSssIndexRoute = AuthenticatedSssIndexRouteImport.update({
  id: '/sss/',
  path: '/sss/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSiteAyarlariIndexRoute =
  AuthenticatedSiteAyarlariIndexRouteImport.update({
    id: '/site-ayarlari/',
    path: '/site-ayarlari/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSertifikalarIndexRoute =
  AuthenticatedSertifikalarIndexRouteImport.update({
    id: '/sertifikalar/',
    path: '/sertifikalar/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSektorlerIndexRoute =
  AuthenticatedSektorlerIndexRouteImport.update({
    id: '/sektorler/',
    path: '/sektorler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSayfalarIndexRoute =
  AuthenticatedSayfalarIndexRouteImport.update({
    id: '/sayfalar/',
    path: '/sayfalar/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSayfaSeoIndexRoute =
  AuthenticatedSayfaSeoIndexRouteImport.update({
    id: '/sayfa-seo/',
    path: '/sayfa-seo/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReferanslarIndexRoute =
  AuthenticatedReferanslarIndexRouteImport.update({
    id: '/referanslar/',
    path: '/referanslar/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMusterilerIndexRoute =
  AuthenticatedMusterilerIndexRouteImport.update({
    id: '/musteriler/',
    path: '/musteriler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMuhendislikIndexRoute =
  AuthenticatedMuhendislikIndexRouteImport.update({
    id: '/muhendislik/',
    path: '/muhendislik/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMedyaIndexRoute = AuthenticatedMedyaIndexRouteImport.update({
  id: '/medya/',
  path: '/medya/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedKullanicilarIndexRoute =
  AuthenticatedKullanicilarIndexRouteImport.update({
    id: '/kullanicilar/',
    path: '/kullanicilar/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedKategorilerIndexRoute =
  AuthenticatedKategorilerIndexRouteImport.update({
    id: '/kategoriler/',
    path: '/kategoriler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIsIlanlariIndexRoute =
  AuthenticatedIsIlanlariIndexRouteImport.update({
    id: '/is-ilanlari/',
    path: '/is-ilanlari/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIletisimMesajlariIndexRoute =
  AuthenticatedIletisimMesajlariIndexRouteImport.update({
    id: '/iletisim-mesajlari/',
    path: '/iletisim-mesajlari/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHeroSliderIndexRoute =
  AuthenticatedHeroSliderIndexRouteImport.update({
    id: '/hero-slider/',
    path: '/hero-slider/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHakkimizdaIndexRoute =
  AuthenticatedHakkimizdaIndexRouteImport.update({
    id: '/hakkimizda/',
    path: '/hakkimizda/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHaberlerIndexRoute =
  AuthenticatedHaberlerIndexRouteImport.update({
    id: '/haberler/',
    path: '/haberler/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGlobalHaritaIndexRoute =
  AuthenticatedGlobalHaritaIndexRouteImport.update({
    id: '/global-harita/',
    path: '/global-harita/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGaleriIndexRoute =
  AuthenticatedGaleriIndexRouteImport.update({
    id: '/galeri/',
    path: '/galeri/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEkipIndexRoute = AuthenticatedEkipIndexRouteImport.update({
  id: '/ekip/',
  path: '/ekip/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBlogIndexRoute = AuthenticatedBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBasvurularIndexRoute =
  AuthenticatedBasvurularIndexRouteImport.update({
    id: '/basvurular/',
    path: '/basvurular/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsLazyRoute =
  AuthenticatedSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDisplayLazyRoute =
  AuthenticatedSettingsDisplayLazyRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/display.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAppearanceLazyRoute =
  AuthenticatedSettingsAppearanceLazyRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/appearance.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountLazyRoute =
  AuthenticatedSettingsAccountLazyRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/google-callback': typeof GoogleCallbackRoute
  '/giris-yap': typeof authGirisYapRoute
  '/otp-dogrulama': typeof authOtpDogrulamaRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/giris-yap-2': typeof authGirisYap2LazyRoute
  '/sifremi-unuttum': typeof authSifremiUnuttumLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/basvurular/': typeof AuthenticatedBasvurularIndexRoute
  '/blog/': typeof AuthenticatedBlogIndexRoute
  '/ekip/': typeof AuthenticatedEkipIndexRoute
  '/galeri/': typeof AuthenticatedGaleriIndexRoute
  '/global-harita/': typeof AuthenticatedGlobalHaritaIndexRoute
  '/haberler/': typeof AuthenticatedHaberlerIndexRoute
  '/hakkimizda/': typeof AuthenticatedHakkimizdaIndexRoute
  '/hero-slider/': typeof AuthenticatedHeroSliderIndexRoute
  '/iletisim-mesajlari/': typeof AuthenticatedIletisimMesajlariIndexRoute
  '/is-ilanlari/': typeof AuthenticatedIsIlanlariIndexRoute
  '/kategoriler/': typeof AuthenticatedKategorilerIndexRoute
  '/kullanicilar/': typeof AuthenticatedKullanicilarIndexRoute
  '/medya/': typeof AuthenticatedMedyaIndexRoute
  '/muhendislik/': typeof AuthenticatedMuhendislikIndexRoute
  '/musteriler/': typeof AuthenticatedMusterilerIndexRoute
  '/referanslar/': typeof AuthenticatedReferanslarIndexRoute
  '/sayfa-seo/': typeof AuthenticatedSayfaSeoIndexRoute
  '/sayfalar/': typeof AuthenticatedSayfalarIndexRoute
  '/sektorler/': typeof AuthenticatedSektorlerIndexRoute
  '/sertifikalar/': typeof AuthenticatedSertifikalarIndexRoute
  '/site-ayarlari/': typeof AuthenticatedSiteAyarlariIndexRoute
  '/sss/': typeof AuthenticatedSssIndexRoute
  '/uretim-sureci/': typeof AuthenticatedUretimSureciIndexRoute
  '/urunler/': typeof AuthenticatedUrunlerIndexRoute
  '/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesByTo {
  '/google-callback': typeof GoogleCallbackRoute
  '/giris-yap': typeof authGirisYapRoute
  '/otp-dogrulama': typeof authOtpDogrulamaRoute
  '/giris-yap-2': typeof authGirisYap2LazyRoute
  '/sifremi-unuttum': typeof authSifremiUnuttumLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/basvurular': typeof AuthenticatedBasvurularIndexRoute
  '/blog': typeof AuthenticatedBlogIndexRoute
  '/ekip': typeof AuthenticatedEkipIndexRoute
  '/galeri': typeof AuthenticatedGaleriIndexRoute
  '/global-harita': typeof AuthenticatedGlobalHaritaIndexRoute
  '/haberler': typeof AuthenticatedHaberlerIndexRoute
  '/hakkimizda': typeof AuthenticatedHakkimizdaIndexRoute
  '/hero-slider': typeof AuthenticatedHeroSliderIndexRoute
  '/iletisim-mesajlari': typeof AuthenticatedIletisimMesajlariIndexRoute
  '/is-ilanlari': typeof AuthenticatedIsIlanlariIndexRoute
  '/kategoriler': typeof AuthenticatedKategorilerIndexRoute
  '/kullanicilar': typeof AuthenticatedKullanicilarIndexRoute
  '/medya': typeof AuthenticatedMedyaIndexRoute
  '/muhendislik': typeof AuthenticatedMuhendislikIndexRoute
  '/musteriler': typeof AuthenticatedMusterilerIndexRoute
  '/referanslar': typeof AuthenticatedReferanslarIndexRoute
  '/sayfa-seo': typeof AuthenticatedSayfaSeoIndexRoute
  '/sayfalar': typeof AuthenticatedSayfalarIndexRoute
  '/sektorler': typeof AuthenticatedSektorlerIndexRoute
  '/sertifikalar': typeof AuthenticatedSertifikalarIndexRoute
  '/site-ayarlari': typeof AuthenticatedSiteAyarlariIndexRoute
  '/sss': typeof AuthenticatedSssIndexRoute
  '/uretim-sureci': typeof AuthenticatedUretimSureciIndexRoute
  '/urunler': typeof AuthenticatedUrunlerIndexRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/chats': typeof AuthenticatedChatsIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/users': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/google-callback': typeof GoogleCallbackRoute
  '/(auth)/giris-yap': typeof authGirisYapRoute
  '/(auth)/otp-dogrulama': typeof authOtpDogrulamaRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(auth)/giris-yap-2': typeof authGirisYap2LazyRoute
  '/(auth)/sifremi-unuttum': typeof authSifremiUnuttumLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountLazyRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayLazyRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsLazyRoute
  '/_authenticated/basvurular/': typeof AuthenticatedBasvurularIndexRoute
  '/_authenticated/blog/': typeof AuthenticatedBlogIndexRoute
  '/_authenticated/ekip/': typeof AuthenticatedEkipIndexRoute
  '/_authenticated/galeri/': typeof AuthenticatedGaleriIndexRoute
  '/_authenticated/global-harita/': typeof AuthenticatedGlobalHaritaIndexRoute
  '/_authenticated/haberler/': typeof AuthenticatedHaberlerIndexRoute
  '/_authenticated/hakkimizda/': typeof AuthenticatedHakkimizdaIndexRoute
  '/_authenticated/hero-slider/': typeof AuthenticatedHeroSliderIndexRoute
  '/_authenticated/iletisim-mesajlari/': typeof AuthenticatedIletisimMesajlariIndexRoute
  '/_authenticated/is-ilanlari/': typeof AuthenticatedIsIlanlariIndexRoute
  '/_authenticated/kategoriler/': typeof AuthenticatedKategorilerIndexRoute
  '/_authenticated/kullanicilar/': typeof AuthenticatedKullanicilarIndexRoute
  '/_authenticated/medya/': typeof AuthenticatedMedyaIndexRoute
  '/_authenticated/muhendislik/': typeof AuthenticatedMuhendislikIndexRoute
  '/_authenticated/musteriler/': typeof AuthenticatedMusterilerIndexRoute
  '/_authenticated/referanslar/': typeof AuthenticatedReferanslarIndexRoute
  '/_authenticated/sayfa-seo/': typeof AuthenticatedSayfaSeoIndexRoute
  '/_authenticated/sayfalar/': typeof AuthenticatedSayfalarIndexRoute
  '/_authenticated/sektorler/': typeof AuthenticatedSektorlerIndexRoute
  '/_authenticated/sertifikalar/': typeof AuthenticatedSertifikalarIndexRoute
  '/_authenticated/site-ayarlari/': typeof AuthenticatedSiteAyarlariIndexRoute
  '/_authenticated/sss/': typeof AuthenticatedSssIndexRoute
  '/_authenticated/uretim-sureci/': typeof AuthenticatedUretimSureciIndexRoute
  '/_authenticated/urunler/': typeof AuthenticatedUrunlerIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/google-callback'
    | '/giris-yap'
    | '/otp-dogrulama'
    | '/settings'
    | '/giris-yap-2'
    | '/sifremi-unuttum'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/basvurular/'
    | '/blog/'
    | '/ekip/'
    | '/galeri/'
    | '/global-harita/'
    | '/haberler/'
    | '/hakkimizda/'
    | '/hero-slider/'
    | '/iletisim-mesajlari/'
    | '/is-ilanlari/'
    | '/kategoriler/'
    | '/kullanicilar/'
    | '/medya/'
    | '/muhendislik/'
    | '/musteriler/'
    | '/referanslar/'
    | '/sayfa-seo/'
    | '/sayfalar/'
    | '/sektorler/'
    | '/sertifikalar/'
    | '/site-ayarlari/'
    | '/sss/'
    | '/uretim-sureci/'
    | '/urunler/'
    | '/apps/'
    | '/chats/'
    | '/help-center/'
    | '/settings/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/google-callback'
    | '/giris-yap'
    | '/otp-dogrulama'
    | '/giris-yap-2'
    | '/sifremi-unuttum'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/basvurular'
    | '/blog'
    | '/ekip'
    | '/galeri'
    | '/global-harita'
    | '/haberler'
    | '/hakkimizda'
    | '/hero-slider'
    | '/iletisim-mesajlari'
    | '/is-ilanlari'
    | '/kategoriler'
    | '/kullanicilar'
    | '/medya'
    | '/muhendislik'
    | '/musteriler'
    | '/referanslar'
    | '/sayfa-seo'
    | '/sayfalar'
    | '/sektorler'
    | '/sertifikalar'
    | '/site-ayarlari'
    | '/sss'
    | '/uretim-sureci'
    | '/urunler'
    | '/apps'
    | '/chats'
    | '/help-center'
    | '/settings'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/google-callback'
    | '/(auth)/giris-yap'
    | '/(auth)/otp-dogrulama'
    | '/_authenticated/settings'
    | '/(auth)/giris-yap-2'
    | '/(auth)/sifremi-unuttum'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/basvurular/'
    | '/_authenticated/blog/'
    | '/_authenticated/ekip/'
    | '/_authenticated/galeri/'
    | '/_authenticated/global-harita/'
    | '/_authenticated/haberler/'
    | '/_authenticated/hakkimizda/'
    | '/_authenticated/hero-slider/'
    | '/_authenticated/iletisim-mesajlari/'
    | '/_authenticated/is-ilanlari/'
    | '/_authenticated/kategoriler/'
    | '/_authenticated/kullanicilar/'
    | '/_authenticated/medya/'
    | '/_authenticated/muhendislik/'
    | '/_authenticated/musteriler/'
    | '/_authenticated/referanslar/'
    | '/_authenticated/sayfa-seo/'
    | '/_authenticated/sayfalar/'
    | '/_authenticated/sektorler/'
    | '/_authenticated/sertifikalar/'
    | '/_authenticated/site-ayarlari/'
    | '/_authenticated/sss/'
    | '/_authenticated/uretim-sureci/'
    | '/_authenticated/urunler/'
    | '/_authenticated/apps/'
    | '/_authenticated/chats/'
    | '/_authenticated/help-center/'
    | '/_authenticated/settings/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  GoogleCallbackRoute: typeof GoogleCallbackRoute
  authGirisYapRoute: typeof authGirisYapRoute
  authOtpDogrulamaRoute: typeof authOtpDogrulamaRoute
  authGirisYap2LazyRoute: typeof authGirisYap2LazyRoute
  authSifremiUnuttumLazyRoute: typeof authSifremiUnuttumLazyRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/google-callback': {
      id: '/google-callback'
      path: '/google-callback'
      fullPath: '/google-callback'
      preLoaderRoute: typeof GoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sifremi-unuttum': {
      id: '/(auth)/sifremi-unuttum'
      path: '/sifremi-unuttum'
      fullPath: '/sifremi-unuttum'
      preLoaderRoute: typeof authSifremiUnuttumLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/giris-yap-2': {
      id: '/(auth)/giris-yap-2'
      path: '/giris-yap-2'
      fullPath: '/giris-yap-2'
      preLoaderRoute: typeof authGirisYap2LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/otp-dogrulama': {
      id: '/(auth)/otp-dogrulama'
      path: '/otp-dogrulama'
      fullPath: '/otp-dogrulama'
      preLoaderRoute: typeof authOtpDogrulamaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/giris-yap': {
      id: '/(auth)/giris-yap'
      path: '/giris-yap'
      fullPath: '/giris-yap'
      preLoaderRoute: typeof authGirisYapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/urunler/': {
      id: '/_authenticated/urunler/'
      path: '/urunler'
      fullPath: '/urunler/'
      preLoaderRoute: typeof AuthenticatedUrunlerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/uretim-sureci/': {
      id: '/_authenticated/uretim-sureci/'
      path: '/uretim-sureci'
      fullPath: '/uretim-sureci/'
      preLoaderRoute: typeof AuthenticatedUretimSureciIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sss/': {
      id: '/_authenticated/sss/'
      path: '/sss'
      fullPath: '/sss/'
      preLoaderRoute: typeof AuthenticatedSssIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/site-ayarlari/': {
      id: '/_authenticated/site-ayarlari/'
      path: '/site-ayarlari'
      fullPath: '/site-ayarlari/'
      preLoaderRoute: typeof AuthenticatedSiteAyarlariIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sertifikalar/': {
      id: '/_authenticated/sertifikalar/'
      path: '/sertifikalar'
      fullPath: '/sertifikalar/'
      preLoaderRoute: typeof AuthenticatedSertifikalarIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sektorler/': {
      id: '/_authenticated/sektorler/'
      path: '/sektorler'
      fullPath: '/sektorler/'
      preLoaderRoute: typeof AuthenticatedSektorlerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sayfalar/': {
      id: '/_authenticated/sayfalar/'
      path: '/sayfalar'
      fullPath: '/sayfalar/'
      preLoaderRoute: typeof AuthenticatedSayfalarIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sayfa-seo/': {
      id: '/_authenticated/sayfa-seo/'
      path: '/sayfa-seo'
      fullPath: '/sayfa-seo/'
      preLoaderRoute: typeof AuthenticatedSayfaSeoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/referanslar/': {
      id: '/_authenticated/referanslar/'
      path: '/referanslar'
      fullPath: '/referanslar/'
      preLoaderRoute: typeof AuthenticatedReferanslarIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/musteriler/': {
      id: '/_authenticated/musteriler/'
      path: '/musteriler'
      fullPath: '/musteriler/'
      preLoaderRoute: typeof AuthenticatedMusterilerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/muhendislik/': {
      id: '/_authenticated/muhendislik/'
      path: '/muhendislik'
      fullPath: '/muhendislik/'
      preLoaderRoute: typeof AuthenticatedMuhendislikIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medya/': {
      id: '/_authenticated/medya/'
      path: '/medya'
      fullPath: '/medya/'
      preLoaderRoute: typeof AuthenticatedMedyaIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kullanicilar/': {
      id: '/_authenticated/kullanicilar/'
      path: '/kullanicilar'
      fullPath: '/kullanicilar/'
      preLoaderRoute: typeof AuthenticatedKullanicilarIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/kategoriler/': {
      id: '/_authenticated/kategoriler/'
      path: '/kategoriler'
      fullPath: '/kategoriler/'
      preLoaderRoute: typeof AuthenticatedKategorilerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/is-ilanlari/': {
      id: '/_authenticated/is-ilanlari/'
      path: '/is-ilanlari'
      fullPath: '/is-ilanlari/'
      preLoaderRoute: typeof AuthenticatedIsIlanlariIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/iletisim-mesajlari/': {
      id: '/_authenticated/iletisim-mesajlari/'
      path: '/iletisim-mesajlari'
      fullPath: '/iletisim-mesajlari/'
      preLoaderRoute: typeof AuthenticatedIletisimMesajlariIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hero-slider/': {
      id: '/_authenticated/hero-slider/'
      path: '/hero-slider'
      fullPath: '/hero-slider/'
      preLoaderRoute: typeof AuthenticatedHeroSliderIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/hakkimizda/': {
      id: '/_authenticated/hakkimizda/'
      path: '/hakkimizda'
      fullPath: '/hakkimizda/'
      preLoaderRoute: typeof AuthenticatedHakkimizdaIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/haberler/': {
      id: '/_authenticated/haberler/'
      path: '/haberler'
      fullPath: '/haberler/'
      preLoaderRoute: typeof AuthenticatedHaberlerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/global-harita/': {
      id: '/_authenticated/global-harita/'
      path: '/global-harita'
      fullPath: '/global-harita/'
      preLoaderRoute: typeof AuthenticatedGlobalHaritaIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/galeri/': {
      id: '/_authenticated/galeri/'
      path: '/galeri'
      fullPath: '/galeri/'
      preLoaderRoute: typeof AuthenticatedGaleriIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ekip/': {
      id: '/_authenticated/ekip/'
      path: '/ekip'
      fullPath: '/ekip/'
      preLoaderRoute: typeof AuthenticatedEkipIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blog/': {
      id: '/_authenticated/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof AuthenticatedBlogIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/basvurular/': {
      id: '/_authenticated/basvurular/'
      path: '/basvurular'
      fullPath: '/basvurular/'
      preLoaderRoute: typeof AuthenticatedBasvurularIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
  }
}

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsAccountLazyRoute: typeof AuthenticatedSettingsAccountLazyRoute
  AuthenticatedSettingsAppearanceLazyRoute: typeof AuthenticatedSettingsAppearanceLazyRoute
  AuthenticatedSettingsDisplayLazyRoute: typeof AuthenticatedSettingsDisplayLazyRoute
  AuthenticatedSettingsNotificationsLazyRoute: typeof AuthenticatedSettingsNotificationsLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsAccountLazyRoute:
      AuthenticatedSettingsAccountLazyRoute,
    AuthenticatedSettingsAppearanceLazyRoute:
      AuthenticatedSettingsAppearanceLazyRoute,
    AuthenticatedSettingsDisplayLazyRoute:
      AuthenticatedSettingsDisplayLazyRoute,
    AuthenticatedSettingsNotificationsLazyRoute:
      AuthenticatedSettingsNotificationsLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBasvurularIndexRoute: typeof AuthenticatedBasvurularIndexRoute
  AuthenticatedBlogIndexRoute: typeof AuthenticatedBlogIndexRoute
  AuthenticatedEkipIndexRoute: typeof AuthenticatedEkipIndexRoute
  AuthenticatedGaleriIndexRoute: typeof AuthenticatedGaleriIndexRoute
  AuthenticatedGlobalHaritaIndexRoute: typeof AuthenticatedGlobalHaritaIndexRoute
  AuthenticatedHaberlerIndexRoute: typeof AuthenticatedHaberlerIndexRoute
  AuthenticatedHakkimizdaIndexRoute: typeof AuthenticatedHakkimizdaIndexRoute
  AuthenticatedHeroSliderIndexRoute: typeof AuthenticatedHeroSliderIndexRoute
  AuthenticatedIletisimMesajlariIndexRoute: typeof AuthenticatedIletisimMesajlariIndexRoute
  AuthenticatedIsIlanlariIndexRoute: typeof AuthenticatedIsIlanlariIndexRoute
  AuthenticatedKategorilerIndexRoute: typeof AuthenticatedKategorilerIndexRoute
  AuthenticatedKullanicilarIndexRoute: typeof AuthenticatedKullanicilarIndexRoute
  AuthenticatedMedyaIndexRoute: typeof AuthenticatedMedyaIndexRoute
  AuthenticatedMuhendislikIndexRoute: typeof AuthenticatedMuhendislikIndexRoute
  AuthenticatedMusterilerIndexRoute: typeof AuthenticatedMusterilerIndexRoute
  AuthenticatedReferanslarIndexRoute: typeof AuthenticatedReferanslarIndexRoute
  AuthenticatedSayfaSeoIndexRoute: typeof AuthenticatedSayfaSeoIndexRoute
  AuthenticatedSayfalarIndexRoute: typeof AuthenticatedSayfalarIndexRoute
  AuthenticatedSektorlerIndexRoute: typeof AuthenticatedSektorlerIndexRoute
  AuthenticatedSertifikalarIndexRoute: typeof AuthenticatedSertifikalarIndexRoute
  AuthenticatedSiteAyarlariIndexRoute: typeof AuthenticatedSiteAyarlariIndexRoute
  AuthenticatedSssIndexRoute: typeof AuthenticatedSssIndexRoute
  AuthenticatedUretimSureciIndexRoute: typeof AuthenticatedUretimSureciIndexRoute
  AuthenticatedUrunlerIndexRoute: typeof AuthenticatedUrunlerIndexRoute
  AuthenticatedAppsIndexLazyRoute: typeof AuthenticatedAppsIndexLazyRoute
  AuthenticatedChatsIndexLazyRoute: typeof AuthenticatedChatsIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedUsersIndexLazyRoute: typeof AuthenticatedUsersIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBasvurularIndexRoute: AuthenticatedBasvurularIndexRoute,
  AuthenticatedBlogIndexRoute: AuthenticatedBlogIndexRoute,
  AuthenticatedEkipIndexRoute: AuthenticatedEkipIndexRoute,
  AuthenticatedGaleriIndexRoute: AuthenticatedGaleriIndexRoute,
  AuthenticatedGlobalHaritaIndexRoute: AuthenticatedGlobalHaritaIndexRoute,
  AuthenticatedHaberlerIndexRoute: AuthenticatedHaberlerIndexRoute,
  AuthenticatedHakkimizdaIndexRoute: AuthenticatedHakkimizdaIndexRoute,
  AuthenticatedHeroSliderIndexRoute: AuthenticatedHeroSliderIndexRoute,
  AuthenticatedIletisimMesajlariIndexRoute:
    AuthenticatedIletisimMesajlariIndexRoute,
  AuthenticatedIsIlanlariIndexRoute: AuthenticatedIsIlanlariIndexRoute,
  AuthenticatedKategorilerIndexRoute: AuthenticatedKategorilerIndexRoute,
  AuthenticatedKullanicilarIndexRoute: AuthenticatedKullanicilarIndexRoute,
  AuthenticatedMedyaIndexRoute: AuthenticatedMedyaIndexRoute,
  AuthenticatedMuhendislikIndexRoute: AuthenticatedMuhendislikIndexRoute,
  AuthenticatedMusterilerIndexRoute: AuthenticatedMusterilerIndexRoute,
  AuthenticatedReferanslarIndexRoute: AuthenticatedReferanslarIndexRoute,
  AuthenticatedSayfaSeoIndexRoute: AuthenticatedSayfaSeoIndexRoute,
  AuthenticatedSayfalarIndexRoute: AuthenticatedSayfalarIndexRoute,
  AuthenticatedSektorlerIndexRoute: AuthenticatedSektorlerIndexRoute,
  AuthenticatedSertifikalarIndexRoute: AuthenticatedSertifikalarIndexRoute,
  AuthenticatedSiteAyarlariIndexRoute: AuthenticatedSiteAyarlariIndexRoute,
  AuthenticatedSssIndexRoute: AuthenticatedSssIndexRoute,
  AuthenticatedUretimSureciIndexRoute: AuthenticatedUretimSureciIndexRoute,
  AuthenticatedUrunlerIndexRoute: AuthenticatedUrunlerIndexRoute,
  AuthenticatedAppsIndexLazyRoute: AuthenticatedAppsIndexLazyRoute,
  AuthenticatedChatsIndexLazyRoute: AuthenticatedChatsIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedUsersIndexLazyRoute: AuthenticatedUsersIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  GoogleCallbackRoute: GoogleCallbackRoute,
  authGirisYapRoute: authGirisYapRoute,
  authOtpDogrulamaRoute: authOtpDogrulamaRoute,
  authGirisYap2LazyRoute: authGirisYap2LazyRoute,
  authSifremiUnuttumLazyRoute: authSifremiUnuttumLazyRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
